import React, { useEffect } from 'react'
import pretty from '@st-operations/uikit/lib/pretty.js'

import { useEventFeedsContext } from '../../../context/index.jsx'
import { formatValue } from '../modal-add-filters/utils.js'
import ManageFilter from '../manage-filter/index.jsx'
import ManageComponent from '../../../manage-component/index.jsx'

import './styles.scss'

const FilterRow = ({ filtersSchema, filter, id }) => {
  const [valueLabel, setValueLabel] = React.useState(null)

  useEffect(() => {
    if (filter.key === 'audience') {
      const audienceName = window.localStorage.getItem(
        `@data-explorer/audience/${filter.value}/name`
      )
      setValueLabel(audienceName)
    }
    return () => {
      localStorage.removeItem(`@data-explorer/audience/${filter.value}/name`)
      setValueLabel(null)
    }
  }, [])

  const formattedValue = formatValue(valueLabel || filter.value, 500) || '-'

  return (
    <tr className="filters-table__tr">
      <td className="filters-table__td">{filtersSchema[filter.key]?.label}</td>
      <td className="filters-table__td filters-table__td--green">
        {pretty(filter.operator) || '-'}
      </td>
      <td className="filters-table__td filters-table__td--light value">
        <span className="filters-table__value" title={formattedValue}>
          {formattedValue}
        </span>
        <ManageComponent>
          <ManageFilter id={id} />
        </ManageComponent>
      </td>
    </tr>
  )
}

const FiltersTable = () => {
  const {
    data,
    schema: {
      // eslint-disable-next-line no-unused-vars
      filters: { type = null, default: defaultKey = null, ...filtersSchema },
    },
  } = useEventFeedsContext()

  return (
    <table className="filters-table">
      <tbody>
        <For each="filter" index="index" of={data?.filters || []}>
          <FilterRow key={filter.key} filtersSchema={filtersSchema} filter={filter} id={index} />
        </For>
        <If condition={(data?.filters || []).length === 0}>
          <tr>
            <td>
              <p className="filters-table__empty-text">{`You haven't added any filters yet.`}</p>
            </td>
          </tr>
        </If>
      </tbody>
    </table>
  )
}

export default React.memo(FiltersTable)
